export default class SupplierEventProduct {
    id: string = "";
    supplierEventID: string | null = null;
    productID: string | null = null;
    productName: string | null = null;
    supplierName: string | null = null;
    currentPriceUSD: number | null = null;
    newProposedPriceUSD: number | null = null;
    newFinalPriceUSD: number | null = null;
    currentINCOTerms: INCOTerms | null = null;
    currentINCOTermsCountryID: string | null = null;
    currentINCOTermsCity: string | null = null;
    newProposedINCOTerms: INCOTerms | null = null;
    newProposedINCOTermsCountryID: string | null = null;
    newProposedINCOTermsCity: string | null = null;
    newFinalINCOTerms: INCOTerms | null = null;
    newFinalINCOTermsCountryID: string | null = null;
    newFinalINCOTermsCity: string | null = null;
    proposedPercentChange: number | null = null;
    finalPercentChange: number | null = null;
    startDate: string | null = null;
    wasNegotiated: boolean | null = null;
    isConsignment: boolean = false;
}

export enum INCOTerms {
    // V 2010	Rules for any mode of transport
    EXW, // Ex Works (named place of delivery)
    FCA, // Free Carrier(named place of delivery)
    CPT, // Carriage Paid To(named place of destination)
    CIP, // Carriage and Insurance Paid to(named place of destination)
    DAT, // Delivered At Terminal(named terminal at port or place of destination)
    DAP, // Delivered At Place(named place of destination)
    DDP, // Delivered Duty Paid(named place of destination)
    // V 2010 Rules for sea and inland waterway transport
    FAS, // Free Alongside Ship(named port of shipment)
    FOB, // Free on Board(named port of shipment)
    CFR, // Cost and Freight(named port of destination)
    CIF, // Cost, Insurance & Freight(named port of destination)
    // Previous terms from Incoterms 2000 eliminated from Incoterms 2010
    //DAF Delivered at Frontier (named place of delivery)
    //DES Delivered Ex Ship
    //DEQ Delivered Ex Quay(named port of delivery)
    DDU, // Delivered Duty Unpaid(named place of destination)
}

//Do it for the UI
export enum UIINCOTerms {
    // V 2010	Rules for any mode of transport
    "EXW", // Ex Works (named place of delivery)
    "FCA", // Free Carrier(named place of delivery)
    "CPT", // Carriage Paid To(named place of destination)
    "CIP", // Carriage and Insurance Paid to(named place of destination)
    "DAT", // Delivered At Terminal(named terminal at port or place of destination)
    "DAP", // Delivered At Place(named place of destination)
    "DDP", // Delivered Duty Paid(named place of destination)
    // V 2010 Rules for sea and inland waterway transport
    "FAS", // Free Alongside Ship(named port of shipment)
    "FOB", // Free on Board(named port of shipment)
    "CFR", // Cost and Freight(named port of destination)
    "CIF", // Cost, Insurance & Freight(named port of destination)
    // Previous terms from Incoterms 2000 eliminated from Incoterms 2010
    //DAF Delivered at Frontier (named place of delivery)
    //DES Delivered Ex Ship
    //DEQ Delivered Ex Quay(named port of delivery)
    "DDU", // Delivered Duty Unpaid(named place of destination)
}
